import { Component, OnInit } from '@angular/core';
import { ApiService } from '../_services';
import { Member } from '../_models';
import { JwtHelper } from '../_services/jwt-helper';
import { AlertPopupService, MessageSeverity } from '../shared/services/alert.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PasswordValidation } from '../register';
import { Dependent } from '../_models/dependent.model';
import { DependentService } from '../_services/dependent.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {

    updateForm: FormGroup;
    openIdTokenParams: any;
    // memberId: string;
    // member: Member;
    // dependent: Dependent;
    // dependentId: string;
    user: any;
    userId: string;
    isDependent: boolean = false;
    changePasswordVM: any = {};
    submitted = false;
  constructor(private formBuilder: FormBuilder,
    private apiService: ApiService, private alertService: AlertPopupService, private dependentService: DependentService) { }


    get f() { return this.updateForm.controls; }

  ngOnInit() {

    this.updateForm = this.formBuilder.group({
        firstName: ['', [Validators.required]],
        lastName: ['', Validators.required],
        address: ['', Validators.required],
        city: ['', Validators.required],
        state: ['', Validators.required],
        zip: ['', Validators.required],

    });

    this.getCurrentUser()
    
  }
  getCurrentUser(){
    this.openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
    if(! this.openIdTokenParams) return;
    let jwtHelper = new JwtHelper();
    let decodedIdToken = jwtHelper.decodeToken(this.openIdTokenParams.id_token);
    this.userId = decodedIdToken.sub;
    if (decodedIdToken.EntityType) { // dependent
      this.isDependent = true;
      this.getDependent()
    }else{ //member
      this.getMember();
    }

  }

  getDependent(){
    this.dependentService.getDependentById(this.userId).subscribe(d => {
      this.user = d ;
      this.user.username = this.user.email;
      console.log(this.user)
    })
  }

  getMember() {
    // if(! this.openIdTokenParams) return;
    // let jwtHelper = new JwtHelper();
    // let decodedIdToken = jwtHelper.decodeToken(this.openIdTokenParams.id_token);
    // this.memberId = decodedIdToken.sub;
    this.apiService.getMemberById(this.userId).subscribe(m => {
      this.user = m as Member;
    })
  }

  updateUser() {

    this.submitted = true;
    // stop here if form is invalid
    // if (this.updateForm.invalid) {
    //     return;
    // }

    if (this.changePasswordVM.password != undefined) {
      if (this.changePasswordVM.password != this.changePasswordVM.confirmPassword) {
        this.alertService.showMessage("The confirm password must match password!", "", MessageSeverity.error);
        return;
      }
      else {
        this.user.password = this.changePasswordVM.password;
      }
    } else {
      this.user.password = undefined;
    }

    this.isDependent ? this.updateDependent() : this.updateMember();

    
  }

  updateMember(){
    this.apiService.updateMember(this.user).subscribe(r => {
      if (r) {
        this.alertService.showMessage("Update Information Successfully!")
      }
    }, err => {
      console.log(err);
    })
  }

  updateDependent(){
    this.dependentService.updatePassowrd(this.user).subscribe(r=> {
      if (r) {
        this.alertService.showMessage("Update Infomation Successfully!")
      }
    }, err => { 
      console.log(err)
     })
  }



}



// WEBPACK FOOTER //
// ./src/app/my-account/my-account.component.ts